import React from 'react';
import { FormControl, InputLabel, Select, FormHelperText, MenuItem, Box, Chip, InputAdornment, IconButton, makeStyles } from '@material-ui/core';
import Loader from '../ui/loaders/Loader';
import { Close, Check } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  positionStart: {
    marginRight: theme.spacing(2.2),
  },
}));

const SelectFormField = ({
  name,
  value,
  label,
  error,
  margin,
  type = 'text',
  helperText,
  options,
  labelKey = 'label',
  valueKey = 'value',
  onChange,
  required = false,
  multiple,
  disabled,
  withoutEmpty = false,
  loading = false,
  fullWidth = true,
  onOpen,
  onClear,
  open,
  endAdornment,
  ...inputProps
}) => {
  const classes = useStyles();
  const renderValue = (selected) => {
    return (
      <Box display='flex' flexWrap='wrap'>
        {selected.map((value) => {
          const found = options.find((option) => option[valueKey] === value);
          const keys = labelKey.split(' ');
          if (!found) {
            return null;
          }
          const label = keys.map((key) => found[key]).join(' ');
          if (!label) {
            return null;
          }
          return <Chip key={value} size='small' label={label} style={{ marginRight: 2, height: '18px' }} />;
        })}
      </Box>
    );
  };

  return (
    <FormControl margin={margin} disabled={disabled} required={required} error={!!error} fullWidth={fullWidth}>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <Select
        value={value === undefined ? '' : value}
        multiple={multiple}
        onChange={onChange}
        placeholder={'цвет'}
        inputProps={{
          name,
          ...inputProps,
        }}

        onOpen={onOpen}
        open={open}
        endAdornment={
          <>
            {(loading || (onClear && multiple && value && value.length > 0)) && (
              <InputAdornment position='start' classes={{ positionStart: classes.positionStart }}>
                {!!loading && <Loader size={16} />}
                {!loading && (multiple ? value && value.length > 0 : !!value) && (
                  <IconButton size='small' onClick={onClear}>
                    <Close />
                  </IconButton>
                )}
              </InputAdornment>
            )}
            {endAdornment}
          </>
        }
        renderValue={multiple && renderValue}
      >
        {!multiple && !withoutEmpty && (
          <MenuItem value={''}>
            <em>Не выбрано</em>
          </MenuItem>
        )}
        {options &&
          options.map((option, index) => {
            const { [valueKey]: valueOption } = option;

            const keys = labelKey.split(' ');
            const label = keys.map((key) => option[key]).join(' ');
            return (
              <MenuItem key={`${name}-${valueOption}-${index}`} value={valueOption}>
                {multiple && Array.isArray(value) ? (
                  value.includes(valueOption) ? (
                    <Box component='span' fontWeight='500'>
                      <Box component='span' mr={1}>
                        <Check fontSize='inherit' />
                      </Box>
                      {label}
                    </Box>
                  ) : (
                    label
                  )
                ) : value === valueOption ? (
                  <Box component='span' fontWeight='500'>
                    {label}
                  </Box>
                ) : (
                  label
                )}
              </MenuItem>
            );
          })}
      </Select>
      {!!helperText && <FormHelperText>{helperText}</FormHelperText>}
      {!!error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
};

export default SelectFormField;
